<template>
  <div class="box">
    <div class="main">
      <div>
        <!-- <Rectangle :path="require('@/assets/img/common/rectangle.png')" /> -->
        <TipsLabel
          :tip="'总条数统计：'"
          :count="selectFile.length"
          :countColor="'#F45B4A'"
        />
        <!--count.toString()-->
        <div style="margin-bottom: 20px">
          <el-button
            type="primary"
            @click="addFile"
            v-if="opType == 1 || opType == 3"
            >新增</el-button
          >
        </div>
      </div>
      <!-- 列表 -->
      <commonTable
        ref="commonTables"
        :data="selectFile"
        :col-configs="tempColConfigs"
        @change-page="handleChangePage"
        :border="true"
        :currentPage="currentPage"
        :pageSize="pageSize"
        :count="count"
      />
      <div class="btn">
        <div v-if="opType == 0">
          <el-button type="primary" @click="nextView('ruleForm')"
            >下一步</el-button
          >
        </div>
        <div v-else>
          <el-button type="primary" @click="goPriveView()">上一步</el-button>
          <el-button
            type="primary"
            v-if="opType == 1 || opType == 3"
            @click="onSubmit('ruleForm')"
            >保存</el-button
          >

          <el-button
            type="primary"
            v-if="opType == 1 || opType == 3"
            @click="onAudit('ruleForm')"
            >提交审核</el-button
          >
          <el-button @click="goBack()">返回</el-button>
        </div>
      </div>
    </div>
    <el-dialog
      :show-close="false"
      title="企业纸质文件配置"
      :visible.sync="outerVisible"
    >
      <div style="padding-right: 5%">
        <el-form ref="ruleFormFile" :model="ruleFormFile" label-width="140px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="资质文件名称" prop="paraId">
                <el-select v-model="ruleFormFile.paraId" placeholder="请选择">
                  <el-option
                    v-for="item in tempFile"
                    :key="item.paraId"
                    :label="item.paraNm"
                    :value="item.paraId.toString()"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="文件说明" prop="rmrk">
                <el-input v-model="ruleFormFile.rmrk"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
          <el-button type="primary" @click="outerVisibleFn(1)">确 定</el-button>
          <el-button @click="outerVisibleFn(2)">取 消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Search from "@/components/public/Element/formSearch.vue";
// import commonTable from "./components/CommonTable/index";
import commonTable from "./index.vue";

import { uploadimg } from "../reqApi";
import { debounce } from "@/utif/timer";
export default {
  //   name: "子产品选择母产品上架",
  name: "certificstuonFile",
  // 注册
  components: {
    Search,
    commonTable,
  },
  props: {
   
    selectFile: {
      type: Array,
      default() {
        return [];
      },
    },
    ruleForm: {
      type: Object,
      default() {
        return {};
      },
    },

    tenantQualParaDictEntities2: {
      type: Array,
      default() {
        return [];
      },
    },
    certificstuonFileData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  watch: {
    selectFile: {
      handler(newData, oldData) {
        console.log(newData);
        let id = [];
        newData.map((item) => {
          id.push(item.paraId);
        });
        this.selectFileId = id;
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {},
  data() {
    return {
      opType: 1,

      action1: "",
      fileList2: [],

      outerVisible: false,
      temprmrk: "", //临时修改备注
      selectFileId: [], //已经选择的id
      tempFile: [], //弹窗的下拉框
      ruleFormFile: {
        //弹窗
        paraId: "",
        rmrk: "",
      },
      currentPage: 10,
      pageSize: 1,
      count: 0,
      isCheckedClick: null,
      tableList: [],
      tempColConfigs: [
        { type: "index", label: "序号", id: -1, width: "50" },
        { type: "paraNm", prop: "paraNm", label: "资质文件名称", id: -1 },
        // { type: "rmrk", prop: "rmrk", label: "缩略图", id: -1 },
        { type: "rmrk", prop: "rmrk", label: "文件说明", id: -1 },

        {
          type: "invSt",
          prop: "invSt",
          label: "状态",
          id: -1,
          render: (operation, record, index) => {
            return <div>{operation == "0" ? "启用" : "停用"}</div>;
          },
        },

        {
          type: "action",
          label: "操作",
          prop: "action",
          render: (operation, record, index) => {
            return (
              <div>
                <el-button
                  type="primary"
                  onClick={this.changeSelectData.bind(
                    this,
                    "edit",
                    record,
                    index
                  )}
                >
                  修改
                </el-button>
                <el-button
                  type="primary"
                  onClick={this.changeSelectData.bind(
                    this,
                    "del",
                    record,
                    index
                  )}
                >
                  删除
                </el-button>
              </div>
            );
          },
          id: -1,
        },
      ],
    };
  },

  mounted() {
    // opType    0  查看 1  修改   3  新增
    let opType = this.$route.query.opType;
    this.opType = opType;
    console.log("查看", this.opType);
    console.log(this.certificstuonFileData, "--------");
    if (opType == 0) {
      this.tempColConfigs.splice(-1, 1); // 除去操作列
    }
  },

  methods: {
    handleChangePage(res) {
      console.log("翻页");
    },
    handleFn(params, index) {
      console.log(params, "wei11");
      if (
        this.$route.query.opType &&
        (this.$route.query.opType == 1 || this.$route.query.opType == 3)
      ) {
        //变成 可编辑
        if (params.invSt && params.invSt == 1) {
          this.certificstuonFileData.forEach((item, i) => {
            if (index == i) {
              item.invSt = 0;
            }
          });
        } else if (params.invSt == 0) {
          this.certificstuonFileData.forEach((item, i) => {
            if (index == i) {
              item.invSt = 1;
            }
          });
        }

        this.$emit("lieinfochild", {
          type: "tenantQualParaDictEntities2",
          value: this.certificstuonFileData,
        });
      }
    },
    onSubmit() {
      this.$emit("submitfnchild");
    },
    nextView() {
      this.$emit("changeTab", 3);
    },
    goPriveView() {
      this.isCheckedClick = "";
      this.$nextTick(() => {
        this.$emit("changeTab", 1);
      });
    },
    // 提交审核
    onAudit: debounce(function () {
      console.log("点击审核");
      this.$emit("subAuditfnchild");
    }, 1000),
    goBack() {
      this.$router.go(-1);
    },
    addFile() {
      if (this.selectFile.length == 0) {
        this.tempFile = this.certificstuonFileData;
      } else {
        let tempselectFile = [];
        let arr = this.selectFileId;
        this.certificstuonFileData.map((item) => {
          if (arr.indexOf(item.paraId) == -1) {
            tempselectFile.push(item);
          }
        });
        this.tempFile = tempselectFile;
      }
      this.$nextTick(() => {
        this.outerVisible = true;
      });
    },
    outerVisibleFn(type) {
      switch (type) {
        case 1:
          // 文件弹窗新增
          this.certificstuonFileData.map((item) => {
            if (item.paraId == this.ruleFormFile.paraId) {
              let tempObje = Object.assign(item, this.ruleFormFile);
              this.selectFile.push(tempObje);
              this.selectFileId.push(item.paraId);
            }
          });
          break;
        case 2:
          // 文件弹窗取消
          // this.temprmrk   修改时有备注，新增时没有备注
          if (this.temprmrk) {
            this.certificstuonFileData.map((item) => {
              if (item.paraId == this.ruleFormFile.paraId) {
                // let tempObje = Object.assign(item, this.ruleFormFile);
                console.log("this.temprmrk", this.temprmrk);
                item.rmrk = this.temprmrk;
                this.selectFile.push(item);
                this.selectFileId.push(item.paraId);
              }
            });
          }
          break;
      }

      this.ruleFormFile = {
        paraId: "",
        rmrk: "",
      };
      this.temprmrk = "";
      this.outerVisible = false;
    },
    changeSelectData(type, record, index) {
      console.log("xiugai");
      switch (type) {
        case "edit":
          this.ruleFormFile = {
            paraId: record.paraId.toString(),
            rmrk: record.rmrk,
          };
          this.temprmrk = record.rmrk;
          this.$nextTick((item) => {
            console.log(this.ruleFormFile);
            this.selectFile.splice(index, 1);
            this.$nextTick((item) => {
              this.getFile();
            });
          });

          break;

        case "del":
          this.selectFile.splice(index, 1);
          break;
      }
    },
    getFile() {
      if (this.selectFile.length == 0) {
        this.tempFile = this.certificstuonFileData;
      } else {
        let tempselectFile = [];
        let arr = this.selectFileId;
        this.certificstuonFileData.map((item) => {
          if (arr.indexOf(item.paraId) == -1) {
            tempselectFile.push(item);
          }
        });
        this.tempFile = tempselectFile;
      }
      this.$nextTick(() => {
        this.outerVisible = true;
      });
    },
    uploadSuccess2(res, file, fileList) {
      //导入
      if (res.ret == 0) {
        this.fileList2 = [
          {
            name: file.name,
            fileId: file.response.data.fileId,
          },
        ];
        this.$message.success(res.msg);
      } else {
        // this.$message.error(res.msg);
      }
    },
  },
};
</script>

<style scoped lang="less">
.box {
  padding: 0;
}

.header {
  margin-top: 8px;
  padding: 20px 0px 10px 0px;
  background-color: #fff;
  width: 100%;
  box-shadow: 3px 3px 5px #e5e8f2;
}

.main {
  margin-top: 8px;
  padding: 20px 4vw;
  background-color: #fff;
  box-shadow: 3px 3px 5px #e5e8f2;
  > div {
    display: flex;
    justify-content: space-between;
  }
  .btn {
    margin-top: 20px;
    justify-content: center !important;
  }
  .el-table {
    .el-table__body-wrapper {
      //特殊处理
      table td .cell .notReadonly {
        color: #1b5bbf;
        cursor: pointer;
      }
    }
  }
}
.c {
  padding: 10px;
  text-align: center;
  margin-bottom: 10vh;
  div {
    margin-left: 0;
  }
}
</style>
